const unlock = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M8.048 1a3.31 3.31 0 0 1 3.305 3.122l.005.188V5h.012l-.001.579 2.101.001V15H2.53V5.58l7.499-.001L10.03 5h.018v-.69l-.005-.153a2.05 2.05 0 0 0-3.639-1.136 6.248 6.248 0 0 0-.23.326l-.074.109L5 3.018l.08-.175A3.31 3.31 0 0 1 8.048 1M8 9a1.32 1.32 0 1 0 1.31 1.28h.01A1.33 1.33 0 0 0 8 9"/></svg>',
};

export { unlock as default };
